export default {
  path: '/standardstore/taskchancecompare',
  meta: {
    title: '机会点对比',
  }
};
